export default __webpack_public_path__ + "48836a64a1b84c5bc49c9c6df8a8dbde.webp";